import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DayBlockPayloadDTO } from '@app/infrastructure/models/day-block';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GradeUnitDayDTO,
  GradeUnitDayListItemDTO,
  IGradeUnitDayListItemDTO,
} from '@app/infrastructure/models/grade-unit/grade-unit-day';

@Component({
  selector: `app-shared-grade-unit-day-detail`,
  template: `<app-shared-grade-unit-day-detail-presentation
    [days]="days"
    [gradeUnitDay]="gradeUnitDay"
    [unitImage]="unitImage"
    (emitSelection)="selectPage($event)"
  ></app-shared-grade-unit-day-detail-presentation>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitDayDetailSmartComponent implements OnInit {
  blocks: DayBlockPayloadDTO[];
  gradeUnitDay: GradeUnitDayDTO;
  days: GradeUnitDayListItemDTO[];
  unitImage: string;

  constructor(private route: ActivatedRoute, private router: Router) {
    const param = 'dayBlocks';
    this.blocks = this.route.snapshot.data[param];
    const gradeUnitDayParam = 'gradeUnitDay';
    this.gradeUnitDay = this.route.snapshot.data[gradeUnitDayParam];
    this.days = this.route.snapshot.data.pages;
    this.unitImage = this.route.snapshot.data.gradeUnit.unitCoverImageUrl;
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  selectPage(event) {
    const url = this.router.url.split('/');
    url.pop();
    const Url = url.join('/') + '/' + event;
    this.router.navigate([Url]);
  }
}
